import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cc-little-loader',
  templateUrl: './little-loader.component.html',
  styleUrls: ['./little-loader.component.scss']
})
export class LittleLoaderComponent implements OnInit {
  @Input() visible: boolean;
  @Input() info: string;
  constructor() {}

  ngOnInit() {}
}
